"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textFontSizes = exports.hintToolbarHeight = exports.headingFontSizes = exports.cardShadowCss = exports.borderRadius = void 0;
var borderRadius = exports.borderRadius = {
  desktop: 2,
  mobile: 4
};
var headingFontSizes = exports.headingFontSizes = {
  xsmall: {
    desktop: 1,
    mobile: 1
  },
  small: {
    desktop: 1.25,
    mobile: 1.1
  },
  normal: {
    desktop: 1.5,
    mobile: 1.25
  },
  large: {
    desktop: 2,
    mobile: 1.5
  }
};
var textFontSizes = exports.textFontSizes = {
  xsmall: {
    desktop: 0.3,
    mobile: 0.1
  },
  small: {
    desktop: 0.85,
    mobile: 0.6
  },
  normal: {
    desktop: 1,
    mobile: 0.85
  },
  large: {
    desktop: 1.5,
    mobile: 1.5
  }
};
var cardShadowCss = exports.cardShadowCss = function cardShadowCss(hoverable) {
  return "\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.05),\n    0 2px 16px 0 rgba(0, 0, 0, 0.10);\n\n  ".concat(hoverable ? "\n    transition: all 0.15s ease;\n\n    &:hover {\n      box-shadow:\n        0 1px 2px 0 rgba(0, 0, 0, 0.05),\n        0 2px 32px 0 rgba(0, 0, 0, 0.20);\n      transform: scale(1.01);\n      z-index: 99;\n    }\n\n    .is-ie-11 &:hover, .is-edge &:hover {\n      transform: scale3d(1.02, 1.02, 1)\n    }\n  " : '', "\n");
};
var hintToolbarHeight = exports.hintToolbarHeight = '4rem';
//# sourceMappingURL=vars.js.map